import ApiHelper from '../lib/api-helper';

const api = new ApiHelper('candidates');

export const getSubmission = async submissionId => {
  const { data } = await api.GET(`/submissions/${submissionId}`);
  return data;
};
